import React from 'react';
import Modal from "react-bootstrap/Modal";
import "../../../styles/vipcode.css";

export const LeaveConfirmModal = ({ show, onCancel, onConfirm }) => {
    return (
        <Modal
            show={show}
            onHide={onCancel}
            centered
            keyboard={false}
            className="leave-confirm-modal"
            backdrop="static"
        >
            <Modal.Header closeButton className="leave-confirm-header" />
            <Modal.Body className="leave-confirm-body">
                <h4 className="leave-confirm-title">Leave This Screen?</h4>
                <p className="leave-confirm-text">
                    If you leave this screen, the information from the scanned QR code will be discarded. Do you want to continue?
                </p>
                <div className="leave-confirm-actions">
                    <button
                        className="leave-confirm-btn leave-confirm-btn--cancel"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="leave-confirm-btn leave-confirm-btn--leave"
                        onClick={onConfirm}
                    >
                        Leave
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default LeaveConfirmModal;
